import { css, styled } from 'styled-components'
import {
  fontSizeCss,
  colorCss,
  mobileFontSizeCss,
  mobileColorCss,
} from 'common/utils/styleUtilsNew'
import { FormInterface } from 'src/shared/types/entities/form-interface'

export interface FormSuccessOptInScreenTextUiStylesInterface
  extends Pick<
    FormInterface['action']['successOptInScreen'],
    'textColor' | 'mobileTextColor'
  > {
  fontSize?: number
  mobileFontSize?: number
  color?: string
  mobileColor?: string
}

export const FormSuccessOptInScreenTextUi = styled.span<FormSuccessOptInScreenTextUiStylesInterface>`
  
  margin-top: 16px;

  word-break: break-word;

  ${fontSizeCss}
  ${colorCss}

  ${p => p.theme.phone} {

    ${mobileFontSizeCss}
    ${mobileColorCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`

    ${mobileFontSizeCss}
    ${mobileColorCss}
  `}
`
